import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'


import { NucleoService } from '../shared/nucleo.service'
import { Nucleo } from '../shared/types'

@Component({
  selector: 'app-nucleo-detalhes',
  templateUrl: './nucleo-detalhes.component.html',
  styleUrls: ['./nucleo-detalhes.component.scss']
})
export class NucleoDetalhesComponent implements OnInit {
  nucleoInfo: Nucleo
  loading: boolean = true

  constructor(
    private nucleoService: NucleoService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.getInformationsPage()
    this.loading = false
  }

  async getInformationsPage() {
    const slug = this.route.snapshot.paramMap.get('slug')

    await this.nucleoService.getDetailsInfo(slug).then(data => {
      this.nucleoInfo = data[0]
    })
  }

}
